import { Collapse, Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import TrendDownIcon from 'src/assets/trend_down.svg';
import TrendUpIcon from 'src/assets/trend_up.svg';
import TrendIcon from 'src/assets/trend.svg';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getAppointmentsSummaryData } from 'src/store/actions/appointment.action';
import { useSelector } from 'react-redux';

const AppointmentsCharts = () => {
  const dispatch = useDispatch();
  const APPOINTMENTS_SUMMARY_TEXT = 'Appointments Summary';
  const [chartsToggleText, setChartsToggleText] = useState(
    APPOINTMENTS_SUMMARY_TEXT
  );
  const [isDetailsVisible, setDetailsVisible] = useState(false);

  const { appointmentsSummary: appointmentsSummaryData } = useSelector(
    (state) => state?.appointmentState
  );

  useEffect(() => {
    dispatch(getAppointmentsSummaryData());
  }, [dispatch]);

  const [selectedFilter, setSelectedFilter] = useState();

  useEffect(() => {
    if (!isEmpty(appointmentsSummaryData?.summary_data)) {
      setSelectedFilter(Object.keys(appointmentsSummaryData?.summary_data)[0]);
    }
  }, [appointmentsSummaryData]);

  const getTitle = useCallback(() => {
    if (!selectedFilter) {
      return (
        <div className="flex justify-between items-center">
          <span>{APPOINTMENTS_SUMMARY_TEXT}</span>
        </div>
      );
    }

    const selectedFilterData =
      appointmentsSummaryData?.summary_data[selectedFilter];
    const summaryText = selectedFilter
      ? `${APPOINTMENTS_SUMMARY_TEXT} (${selectedFilter.toUpperCase()})`
      : APPOINTMENTS_SUMMARY_TEXT;

    return (
      <div className="flex justify-between flex-wrap items-center md:gap-4">
        <span>{summaryText}</span>
        {selectedFilter &&
          selectedFilterData.map((appointmentFilter) => {
            return (
              <span
                key={appointmentFilter.title}
                className="flex justify-center items-center gap-3"
              >
                <span className="">
                  {appointmentFilter.title}
                  {': '}
                  {appointmentFilter.value}
                </span>
                {renderTrendData(appointmentFilter.trend)}
              </span>
            );
          })}
      </div>
    );
  }, [appointmentsSummaryData?.summary_data, selectedFilter]);

  useEffect(() => {
    if (!isEmpty(appointmentsSummaryData?.summary_data)) {
      setChartsToggleText(getTitle());
    }
  }, [appointmentsSummaryData?.summary_data, getTitle]);

  const onChange = (keys) => {
    setDetailsVisible(!isEmpty(keys));
  };

  useEffect(() => {
    setChartsToggleText(isDetailsVisible ? '' : getTitle());
  }, [isDetailsVisible, getTitle]);

  if (
    isEmpty(appointmentsSummaryData?.summary_data) ||
    isEmpty(selectedFilter)
  ) {
    return null;
  }

  const renderComparisonSubText = () =>
    selectedFilter ? (
      <div className="text-xs text-gray-500 mt-2">{`From last ${selectedFilter
        .slice(0, -2)
        .toLowerCase()}`}</div>
    ) : null;

  const renderTrendData = (trendValue) => {
    return trendValue >= 0 ? (
      <span className="flex items-center justify-end bg-green-600 py-0.5 px-1 rounded-xl min-w-fit">
        <img src={TrendIcon} alt="value up" />
        <span className="text-white font-medium mx-1">+ {trendValue}</span>
      </span>
    ) : (
      <span className="flex items-center justify-end bg-red-400 py-0.5 px-1 rounded-xl min-w-fit">
        <img src={TrendIcon} alt="value down" className="-scale-y-100" />
        <span className="text-white font-medium mx-1">{trendValue}</span>
      </span>
    );
  };

  return (
    <Collapse
      className="mt-2 mb-5 border-none relative"
      onChange={onChange}
      items={[
        {
          label: <span className="font-semibold">{chartsToggleText}</span>,
          children: (
            <div className="rounded-lg">
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-xs">
                  Last updated:{' '}
                  {moment
                    .utc(appointmentsSummaryData.last_updated)
                    .local()
                    .format('MMM D, YYYY h:mm A')}
                </span>
                <Radio.Group
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                >
                  {Object.keys(appointmentsSummaryData.summary_data).map(
                    (appointmentFilter) => {
                      return (
                        <Radio.Button
                          key={appointmentFilter}
                          value={appointmentFilter}
                        >
                          <span className="capitalize">
                            {appointmentFilter}
                          </span>
                        </Radio.Button>
                      );
                    }
                  )}
                </Radio.Group>
              </div>
              <div className="flex justify-between items-center my-2.5">
                {appointmentsSummaryData.summary_data[selectedFilter].map(
                  (appointmentValue) => {
                    return (
                      <div
                        className="w-[32%] bg-white rounded-lg p-5 border border-gray-200"
                        key={appointmentValue.title}
                      >
                        <h3 className="text-sm font-medium">
                          {appointmentValue.title}
                        </h3>
                        <div className="flex justify-between mt-4 items-center">
                          <h3 className="text-4xl	font-semibold">
                            {appointmentValue.value}
                          </h3>
                          {appointmentValue.trend >= 0 ? (
                            <div>
                              <div className="flex items-center justify-end">
                                {renderTrendData(appointmentValue.trend)}
                                <img src={TrendUpIcon} alt="trend up" />
                              </div>
                              {renderComparisonSubText()}
                            </div>
                          ) : (
                            <div>
                              <div className="flex items-center justify-end">
                                {renderTrendData(appointmentValue.trend)}
                                <img src={TrendDownIcon} alt="trend up" />
                              </div>
                              {renderComparisonSubText()}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          ),
        },
      ]}
    />
  );
};

export default AppointmentsCharts;
